import { date, object, string } from "yup";
import * as Yup from "yup";

const passwordType = Yup.string()
  .required("Aucun mot de passe spécifié")
  .min(2, "Votre mot de passe trop court")
  .matches(/(?=.*[0-9])/, "Votre mot de passe doit contenir un chiffre.");

const userValidationSchema = object().shape({
  email: Yup.string()
    .email()
    .required("Email requis"),
  denomination: Yup.string().required(
    "Dénomination nécessaire. Si AE, renseignez votre nom."
  ),
  firstName: Yup.string()
    .min(2, "Prénom trop court")
    .required("Prénom requis"),
  lastName: Yup.string()
    .min(1, "Nom requis")
    .required("Nom requis"),
  password: Yup.string()
    .required("Aucun mot de passe spécifié")
    .min(2, "Votre mot de passe trop court")
    .matches(/(?=.*[0-9])/, "Votre mot de passe doit contenir un chiffre."),
  passwordConfirmation: Yup.string().when("password", (password, field) =>
    password
      ? field
          .required("Vous devez confirmer votre mot de passe")
          .oneOf(
            [Yup.ref("password"), null],
            "Les mots de passe ne correspondent pas"
          )
      : field
  )
});

export const userProfileValidationSchema = object().shape({
  email: Yup.string()
    .email()
    .required("Email requis"),

  firstName: Yup.string()
    .min(2, "Prénom trop court")
    .required("Prénom requis"),
  lastName: Yup.string()
    .min(1, "Nom requis")
    .required("Nom requis"),
  password: Yup.string()
    .required("Aucun mot de passe spécifié")
    .min(2, "Votre mot de passe trop court")
    .matches(/(?=.*[0-9])/, "Votre mot de passe doit contenir un chiffre."),
  passwordConfirmation: Yup.string().when("password", (password, field) =>
    password
      ? field
          .required("Vous devez confirmer votre mot de passe")
          .oneOf(
            [Yup.ref("password"), null],
            "Les mots de passe ne correspondent pas"
          )
      : field
  )
});

export const userNewPasswordValidationSchema = object().shape({
  oldPassword: passwordType,
  newPassword: passwordType,
  passwordConfirmation: Yup.string().when("newPassword", (password, field) =>
    password
      ? field
          .required("Vous devez confirmer votre mot de passe")
          .oneOf(
            [Yup.ref("newPassword"), null],
            "Les mots de passe ne correspondent pas"
          )
      : field
  )
});

export const emailValidationSchema = object().shape({
  email: Yup.string()
    .email()
    .required("Email requis")
});

export const passwordValidationSchema = object().shape({
  password: Yup.string()
    .required("Aucun mot de passe spécifié")
    .min(2, "Votre mot de passe trop court")
    .matches(/(?=.*[0-9])/, "Votre mot de passe doit contenir un chiffre."),
  passwordConfirmation: Yup.string().when("password", (password, field) =>
    password
      ? field
          .required("Vous devez confirmer votre mot de passe")
          .oneOf(
            [Yup.ref("password"), null],
            "Les mots de passe ne correspondent pas"
          )
      : field
  )
});

export default userValidationSchema;
